import { configureStore } from '@reduxjs/toolkit';
import { auth } from './auth/reducer';
import { operations } from './operations/reducer';
import { error } from './error/reducer';
import { handle } from './handles/reducer';
import { scheduler } from './scheduler/reducer';
import { growth } from './growth/reducer';
import { bots } from './bots/reducer';
import { botActivity } from './botActivity/reducer';
import { analytics } from './analytics/reducer';

const store = configureStore({
    reducer: {
        auth,
        operations,
        error,
        handle,
        scheduler,
        growth,
        bots,
        botActivity,
        analytics,
    },
    // Redux Toolkit includes thunk middleware by default
    // Redux DevTools extension is automatically enabled in development
});

export default store;